// modules/BaseWorld/BaseWorldMultiplayer.js
// 基础世界场景多人游戏模块

import MultiplayerPlayerManager from '../MultiplayerPlayerManager.js';
import TeamManager from '../TeamManager.js';
import ChatSystem from '../ChatSystem.js';
import DebugHelper from '../DebugHelper.js';
import ErrorHandler from '../ErrorHandler.js';

export default class BaseWorldMultiplayer {
    constructor(scene) {
        this.scene = scene;
    }
    
    /**
     * 初始化多人游戏功能
     * @param {Object} networkManager - 网络管理器
     */
    initializeMultiplayer(networkManager) {
        try {
            // 创建多人玩家管理器
            this.scene.multiplayerPlayerManager = new MultiplayerPlayerManager(this.scene, networkManager);
            this.scene.multiplayerPlayerManager.init();
            
            // 创建组队管理器
            this.scene.teamManager = new TeamManager(this.scene, networkManager);
            this.scene.teamManager.init();
            
            // 创建聊天系统
            this.scene.chatSystem = new ChatSystem(this.scene, networkManager);
            this.scene.chatSystem.init();
            
            DebugHelper.log('多人游戏功能已初始化');
        } catch (error) {
            ErrorHandler.handleError(error, '多人游戏初始化', this.scene);
        }
    }
    
    /**
     * 检查是否是队长
     * @returns {boolean} 是否是队长
     */
    isTeamLeader() {
        return this.scene.teamManager && this.scene.teamManager.isTeamLeader();
    }
    
    /**
     * 获取队伍ID
     * @returns {string|null} 队伍ID
     */
    getTeamId() {
        return this.scene.teamManager ? this.scene.teamManager.getTeamId() : null;
    }
    
    /**
     * 更新本地玩家位置
     * @param {number} x - X坐标
     * @param {number} y - Y坐标
     * @param {string} direction - 方向
     */
    updateLocalPlayerPosition(x, y, direction) {
        if (this.scene.multiplayerPlayerManager && this.scene.isMultiplayer) {
            this.scene.multiplayerPlayerManager.updateLocalPlayerPosition(x, y, direction);
        }
    }
    
    /**
     * 更新队员位置
     */
    updateTeamMemberPositions() {
        if (this.scene.multiplayerPlayerManager && this.isTeamLeader()) {
            if (typeof this.scene.multiplayerPlayerManager.updateTeamMemberPositions === 'function') {
                this.scene.multiplayerPlayerManager.updateTeamMemberPositions();
            } else {
                DebugHelper.warn('updateTeamMemberPositions方法不存在');
            }
        }
    }
    
    /**
     * 更新跟随者位置
     * @param {Object} currentSprite - 当前控制的精灵
     */
    updateFollowerPosition(currentSprite) {
        if (this.scene.multiplayerPlayerManager && currentSprite && !this.isTeamLeader()) {
            this.scene.multiplayerPlayerManager.updateFollowerPosition(currentSprite);
        }
    }
}

